import React from 'react';
import { useGoalReduceCreditUsageWithLimitIncrease } from './hooks/goalGoalReduceCreditUsageWithLimitIncrease';
import GoalReduceCreditUsageWithLimitIncreaseView from './GoalReduceCreditUsageWithLimitIncreaseView';

const GoalReduceCreditUsageWithLimitIncreaseController = props => {
  const reduceCreditUsageHook =
    useGoalReduceCreditUsageWithLimitIncrease(props);
  return (
    <GoalReduceCreditUsageWithLimitIncreaseView
      {...props}
      {...reduceCreditUsageHook}
      offers={props?.offers ?? []}
    />
  );
};

export default GoalReduceCreditUsageWithLimitIncreaseController;
